import { render, staticRenderFns } from "./lever_exchange.vue?vue&type=template&id=04b8aff1&scoped=true&"
import script from "./lever_exchange.vue?vue&type=script&lang=js&"
export * from "./lever_exchange.vue?vue&type=script&lang=js&"
import style0 from "./lever_exchange.vue?vue&type=style&index=0&id=04b8aff1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b8aff1",
  null
  
)

export default component.exports